export const timeoutScreenInitialState = {
  visible: false,
};

export const timeoutScreenReducer = (state, action) => {
  switch (action.type) {
    case 'SET_TIMEOUT_SCREEN_VISIBLE':
      return {
        ...state,
        visible: action.payload,
      };
    default:
      return state;
  }
};
